import React, { useState, useRef, useEffect, useContext } from "react";
import { useTheme } from "@mui/material/styles";

import { useNavigate, useLocation } from "react-router-dom";
import { format } from "date-fns";

import useSound from "use-sound";

import Popover from "@mui/material/Popover";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import Badge from "@mui/material/Badge";
import useMediaQuery from "@mui/material/useMediaQuery";

import ResponsiveSheet from "../ResponsiveSheet";
import TicketListItem from "../TicketListItem";
import useTickets from "../../hooks/useTickets";
import alertSound from "../../assets/sound.mp3";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import Favicon from "react-favicon";
import { getBackendUrl } from "../../config";
import defaultLogoFavicon from "../../assets/favicon.ico";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import useWhatsApps from "../../hooks/useWhatsApps";
import { toast } from "react-toastify";


const NotificationsPopOver = (volume) => {
	const theme = useTheme();
	// RDS-FIX-NOTIFICATIONS-MOBILE: en móvil el Popover anclado al ícono
	// quedaba cortado contra los bordes / montado sobre el topbar (44px,
	// muy poco espacio para anclar un panel de 270-350px de ancho). Mismo
	// breakpoint que el resto de la app (down("md")) para pasar al patrón
	// de bottom-sheet ya establecido (ResponsiveSheet) -- en desktop el
	// Popover sigue exactamente igual, sin cambios.
	const isMobileLayout = useMediaQuery(theme.breakpoints.down("md"));

	const navigate = useNavigate();
	const location = useLocation();
	// const socketManager = useContext(SocketContext);
	const { user, socket } = useContext(AuthContext);
	const { profile, queues } = user;

	const ticketIdUrl = +location.pathname.split("/")[2];
	const ticketIdRef = useRef(ticketIdUrl);
	const anchorEl = useRef();
	const [isOpen, setIsOpen] = useState(false);
	const [notifications, setNotifications] = useState([]);
	const queueIds = queues.map((q) => q.id);
	const { get: getSetting } = useCompanySettings();
    const { setCurrentTicket, setTabOpen } = useContext(TicketsContext);
    const { whatsApps } = useWhatsApps();
    const hasHiddenGroupConnections = whatsApps.some(w => w.allowGroup && !w.showGroupNotification);

	const [showTicketWithoutQueue, setShowTicketWithoutQueue] = useState(false);
	const [showNotificationPending, setShowNotificationPending] = useState(false);
	const [showGroupNotification, setShowGroupNotification] = useState(false);

	const [, setDesktopNotifications] = useState([]);

	const { tickets } = useTickets({
		withUnreadMessages: "true"
		// showAll: showTicketWithoutQueue ? "true" : "false"
	});

	const [play] = useSound(alertSound, volume);
	const soundAlertRef = useRef();


	useEffect(() => {
		const fetchSettings = async () => {
			try {
				const setting = await getSetting(
					{
						"column": "showNotificationPending"
					}
				);



				if (setting.showNotificationPending === true) {
					setShowNotificationPending(true);
				}

				if (user.allTicket === "enable") {
					setShowTicketWithoutQueue(true);
				}
				if (user.allowGroup === true) {
					setShowGroupNotification(true);
				}
			} catch (err) {
				toastError(err);
			}
		}

		fetchSettings();
	}, [setShowTicketWithoutQueue, setShowNotificationPending]);

	useEffect(() => {
		soundAlertRef.current = play;

		if (!("Notification" in window)) {
		} else {
			Notification.requestPermission();
		}
	}, [play]);

	useEffect(() => {
		const processNotifications = () => {
			// if (showTicketWithoutQueue) {
			setNotifications(tickets.filter(t => !t.isGroup || t.whatsapp?.showGroupNotification));
			// } else {
			// 	const newNotifications = tickets.filter(ticket => ticket.status !== "pending");

			// 	setNotifications(newNotifications);
			// }
		}

		processNotifications();
	}, [tickets]);

	useEffect(() => {
		ticketIdRef.current = ticketIdUrl;
	}, [ticketIdUrl]);

	useEffect(() => {
		const companyId = user.companyId;
		// const socket = socketManager.GetSocket();
		if (user.id && socket) {
			const queueIds = queues.map((q) => q.id);

			const onConnectNotificationsPopover = () => {
				socket.emit("joinNotification");
			}

			const onCompanyTicketNotificationsPopover = (data) => {
				if (data.action === "updateUnread" || data.action === "delete") {
					setNotifications(prevState => {
						const ticketIndex = prevState.findIndex(t => t.id === data.ticketId);
						if (ticketIndex !== -1) {
							prevState.splice(ticketIndex, 1);
							return [...prevState];
						}
						return prevState;
					});

					setDesktopNotifications(prevState => {
						const notfiticationIndex = prevState.findIndex(
							n => n.tag === String(data.ticketId)
						);
						if (notfiticationIndex !== -1) {
							prevState[notfiticationIndex].close();
							prevState.splice(notfiticationIndex, 1);
							return [...prevState];
						}
						return prevState;
					});
				}
			};

// Adicione esta lógica no componente NotificationsPopOver
const onCompanyAppMessageNotificationsPopover = (data) => {
    // Los mensajes de grupo nunca disparan badge/sonido/Notification() del navegador.
    // El chat en tiempo real (MessagesList) y el preview del sidebar (TicketsListCustom)
    // siguen recibiendo el mismo evento sin cambios -- solo se corta aqui.
    if (data.ticket?.isGroup === true && !data.ticket?.whatsapp?.showGroupNotification) return;

    if (
        data.action === "create" && !data.message.fromMe &&
        !data.message.read &&
        (data.ticket?.userId === user?.id || !data.ticket?.userId) &&
        (user?.queues?.some(queue => (queue.id === data.ticket.queueId)) ||
            !data.ticket.queueId && showTicketWithoutQueue === true) &&
        (!["pending", "lgpd", "nps", "group"].includes(data.ticket?.status) ||
            (data.ticket?.status === "pending" && showNotificationPending === true) ||
            (data.ticket?.status === "group" && data.ticket?.whatsapp?.groupAsTicket === "enabled" && showGroupNotification === true))
    ) {
        // Aplicar lógica de permissão para mensagens pending
        const shouldBlurMessages = data.ticket.status === "pending" && user.allowSeeMessagesInPendingTickets === "disabled";
        
        // Se deve ocultar a mensagem, modifique o ticket antes de adicioná-lo às notificações
        const ticketToAdd = shouldBlurMessages 
            ? {
                ...data.ticket,
                lastMessage: i18n.t("notifications.messageHidden") // ou "Mensagem oculta"
              }
            : data.ticket;

        setNotifications(prevState => {
            const ticketIndex = prevState.findIndex(t => t.id === ticketToAdd.id);
            if (ticketIndex !== -1) {
                prevState[ticketIndex] = ticketToAdd;
                return [...prevState];
            }
            return [ticketToAdd, ...prevState];
        });

        const shouldNotNotificate =
            (data.message.ticketId === ticketIdRef.current &&
                document.visibilityState === "visible") ||
            (data.ticket.userId && data.ticket.userId !== user?.id) ||
            (data.ticket.isGroup && data.ticket?.whatsapp?.groupAsTicket === "disabled" && showGroupNotification === false);

        if (shouldNotNotificate === true) return;

        // Para notificações desktop, também aplicar a lógica de ocultação
        const messageBody = shouldBlurMessages 
            ? i18n.t("notifications.messageHidden")
            : data.message.body;

        handleNotifications({
            ...data,
            message: {
                ...data.message,
                body: messageBody
            }
        });
    }
}

			// FASE-RETURN-TO-AGENT (frontend, aprobado): el flujo que un
			// agente disparo manualmente (con la devolucion activa) termino
			// y el ticket regreso a el -- toast con boton para abrir el
			// ticket directo, sin esperar a que el agente lo note en la
			// lista. El payload viene de FlowReturnToAgentService.ts
			// (backend): {ticketId, ticketUuid, title, body}.
			const onUserFlowReturnNotificationsPopover = (data) => {
				const { ticketUuid, title, body } = data || {};
				if (!ticketUuid) return;

				toast.info(
					<Box>
						<Typography sx={{ fontWeight: 600, fontSize: 13 }}>{title}</Typography>
						<Typography sx={{ fontSize: 12, mb: "6px" }}>{body}</Typography>
						<Typography
							component="span"
							onClick={() => navigate(`/tickets/${ticketUuid}`)}
							sx={{
								fontSize: 12,
								fontWeight: 600,
								color: "#0399FF",
								cursor: "pointer",
								textDecoration: "underline",
							}}
						>
							Abrir ticket
						</Typography>
					</Box>,
					{ autoClose: 10000 }
				);
			};

			// Regresion real (ticket 423, empresa 2, 2026-10-24): el agente de
			// IA fallo 2 veces en pocos minutos sin que nadie del equipo se
			// enterara hasta que el cliente se quejo. Solo para admins (el
			// backend ya filtra por companyId via el namespace del socket,
			// pero esta alerta es ruido para cualquiera que no pueda hacer
			// nada al respecto -- ver AiAgentRuntimeService.ts,
			// notifyAdminsOfRepeatedFailure).
			const onAiAgentAlertNotificationsPopover = (data) => {
				if (profile !== "admin") return;
				const { message, ticketUuid } = data || {};
				toast.warning(
					<Box>
						<Typography sx={{ fontWeight: 600, fontSize: 13 }}>Shessai IA con fallas repetidas</Typography>
						<Typography sx={{ fontSize: 12, mb: ticketUuid ? "6px" : 0 }}>{message}</Typography>
						{ticketUuid && (
							<Typography
								component="span"
								onClick={() => navigate(`/tickets/${ticketUuid}`)}
								sx={{ fontSize: 12, fontWeight: 600, color: "#0399FF", cursor: "pointer", textDecoration: "underline" }}
							>
								Ver el ultimo ticket afectado
							</Typography>
						)}
					</Box>,
					{ autoClose: 15000 }
				);
			};

			// Regresion de transcripcion de audio (ticket 423, empresa 2,
			// 2026-10-25, pedido explicito: "alerta a los admins... igual
			// que la del agente") -- mismo patron exacto que
			// onAiAgentAlertNotificationsPopover arriba, ver
			// VoiceTranscriptionHealthService.ts.
			const onVoiceWorkerAlertNotificationsPopover = (data) => {
				if (profile !== "admin") return;
				const { message } = data || {};
				toast.warning(
					<Box>
						<Typography sx={{ fontWeight: 600, fontSize: 13 }}>Transcripcion de audio con fallas repetidas</Typography>
						<Typography sx={{ fontSize: 12 }}>{message}</Typography>
					</Box>,
					{ autoClose: 15000 }
				);
			};

        if (!socket) return;
			socket.on("connect", onConnectNotificationsPopover);
			socket.on(`company-${companyId}-ticket`, onCompanyTicketNotificationsPopover);
			socket.on(`company-${companyId}-appMessage`, onCompanyAppMessageNotificationsPopover);
			socket.on(`user-${user.id}-flow-return`, onUserFlowReturnNotificationsPopover);
			socket.on(`company-${companyId}-aiAgentAlert`, onAiAgentAlertNotificationsPopover);
			socket.on(`company-${companyId}-voiceWorkerAlert`, onVoiceWorkerAlertNotificationsPopover);

			return () => {
				socket.off("connect", onConnectNotificationsPopover);
				socket.off(`company-${companyId}-ticket`, onCompanyTicketNotificationsPopover);
				socket.off(`company-${companyId}-appMessage`, onCompanyAppMessageNotificationsPopover);
				socket.off(`user-${user.id}-flow-return`, onUserFlowReturnNotificationsPopover);
				socket.off(`company-${companyId}-aiAgentAlert`, onAiAgentAlertNotificationsPopover);
				socket.off(`company-${companyId}-voiceWorkerAlert`, onVoiceWorkerAlertNotificationsPopover);
			};
		}
		return undefined;
	}, [user, profile, queues, showTicketWithoutQueue, socket, showNotificationPending, showGroupNotification]);

	const handleNotifications = data => {
		const { message, contact, ticket } = data;

		const options = {
			body: `${message.body} - ${format(new Date(), "HH:mm")}`,
			icon: contact.urlPicture,
			tag: ticket.id,
			renotify: true,
		};
		const notification = new Notification(
			`${i18n.t("tickets.notification.message")} ${contact.name}`,
			options
		);

		notification.onclick = e => {
			e.preventDefault();
			window.focus();
			setTabOpen(ticket.status)
			navigate(`/tickets/${ticket.uuid}`);
			// handleChangeTab(null, ticket.isGroup? "group" : "open");
		};

		setDesktopNotifications(prevState => {
			const notfiticationIndex = prevState.findIndex(
				n => n.tag === notification.tag
			);
			if (notfiticationIndex !== -1) {
				prevState[notfiticationIndex] = notification;
				return [...prevState];
			}
			return [notification, ...prevState];
		});
		soundAlertRef.current();
	};

	const handleClick = () => {
		setIsOpen(prevState => !prevState);
	};

	const handleClickAway = () => {
		setIsOpen(false);
	};

	const NotificationTicket = ({ children }) => {
		return <div onClick={handleClickAway}>{children}</div>;
	};

	const browserNotification = () => {
		const numbers = "⓿➊➋➌➍➎➏➐➑➒➓⓫⓬⓭⓮⓯⓰⓱⓲⓳⓴";
		if (notifications.length > 0) {
			if (notifications.length < 21) {
				document.title = numbers.substring(notifications.length, notifications.length + 1) + " - " + (theme.appName || "...");
			} else {
				document.title = "(" + notifications.length + ")" + (theme.appName || "...");
			}
		} else {
			document.title = theme.appName || "...";
		}
		return (
			<>
				<Favicon
					animated={true}
					url={(theme?.appLogoFavicon) ? theme.appLogoFavicon : defaultLogoFavicon}
					alertCount={notifications.length}
					iconSize={195}
				/>
			</>
		);
	};

	// RDS-FIX-NOTIFICATIONS-MOBILE: mismo contenido (List + aviso de
	// grupos ocultos) para las dos ramas -- Popover en desktop (sin
	// cambios) y ResponsiveSheet en móvil, ver abajo. Nada de lógica de
	// datos/estado/sonido se tocó, solo el contenedor visual que lo envuelve.
	const notificationListContent = (
		<>
			<List dense sx={theme => ({ overflowY: "auto", maxHeight: 350, ...theme.scrollbarStyles })}>
				{notifications.length === 0 ? (
					<Box sx={{
						display: "flex", flexDirection: "column", alignItems: "center",
						justifyContent: "center", py: "28px", px: "16px", gap: "8px",
					}}>
						<Box sx={{
							width: 36, height: 36, borderRadius: "10px",
							background: theme.palette.mode === "dark" ? "rgba(3,153,255,0.12)" : "#eff6ff",
							display: "flex", alignItems: "center", justifyContent: "center",
						}}>
							<NotificationsOutlinedIcon sx={{ fontSize: 18, color: "#0399FF" }} />
						</Box>
						<Typography sx={{ fontSize: 12, fontWeight: 500, color: theme.palette.mode === "dark" ? theme.palette.text.primary : "rgba(0,0,0,0.55)" }}>
							Sin notificaciones
						</Typography>
						<Typography sx={{ fontSize: 11, color: theme.palette.mode === "dark" ? theme.palette.text.secondary : "rgba(0,0,0,0.35)", textAlign: "center" }}>
							Las notificaciones aparecerán aquí
						</Typography>
					</Box>
				) : (
					notifications.map(ticket => (
						<NotificationTicket key={ticket.id}>
							<TicketListItem ticket={ticket} />
						</NotificationTicket>
					))
				)}
			</List>

			{hasHiddenGroupConnections && (
				<Box sx={{
					px: "14px", py: "8px",
					borderTop: theme => `1px solid ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)"}`,
				}}>
					<Typography sx={{ fontSize: 11, color: "text.secondary", textAlign: "center" }}>
						Los grupos no muestran notificaciones aquí — actívalo en Conexiones si lo necesitas
					</Typography>
				</Box>
			)}
		</>
	);

	return (
		<>
			{browserNotification()}

			<IconButton
				onClick={handleClick}
				ref={anchorEl}
				aria-label="Open Notifications"
				color="inherit"
				sx={{ color: (theme) => theme.palette.mode === "dark" ? "rgba(255,255,255,0.55)" : "rgba(0,0,0,0.5)" }}
			>
				<Badge
					overlap="rectangular"
					badgeContent={notifications.length}
					sx={{
						"& .MuiBadge-badge": {
							background: "var(--sh-gradient)",
							color: "#fff",
							boxShadow: "0 0 6px rgba(3,153,255,0.5)",
						},
					}}
				>
					<NotificationsOutlinedIcon />
				</Badge>
			</IconButton>

			{isMobileLayout ? (
				<ResponsiveSheet open={isOpen} onClose={handleClickAway}>
					{notificationListContent}
				</ResponsiveSheet>
			) : (
				<Popover
					disableScrollLock
					open={isOpen}
					anchorEl={anchorEl.current}
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "right",
					}}
					transformOrigin={{
						vertical: "top",
						horizontal: "right",
					}}
					PaperProps={{ sx: theme => ({ width: "100%", maxWidth: 350, marginLeft: theme.spacing(2), marginRight: theme.spacing(1), borderRadius: "12px", border: theme.palette.mode==="dark" ? "0.5px solid rgba(255,255,255,0.10)" : "0.5px solid rgba(0,0,0,0.08)", boxShadow: theme.palette.mode==="dark" ? "0 8px 24px rgba(0,0,0,0.4)" : "0 8px 24px rgba(0,0,0,0.10)", [theme.breakpoints.down("sm")]: { maxWidth: 270 } }) }}
					onClose={handleClickAway}
				>
					{notificationListContent}
				</Popover>
			)}
		</>
	);
};

export default NotificationsPopOver;